import { HttpError } from './http.error';

export class ValidationError extends HttpError {
  messages: string[];

  constructor(messages: string | string[] = []) {
    super(400, Array.isArray(messages) ? messages.join(', ') : messages);
    this.messages = Array.isArray(messages) ? messages : [messages];
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/common/models/validation.error.ts